import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrl: './blog-grid.component.css'
})
export class BlogGridComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  blogPosts = [
    {
      img: 'assets/images/blogs/blog-1.jpg',
      date: 'April 19',
      title: 'Improving daily life with an AI meal plan',
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    },
    {
      img: 'assets/images/blogs/blog-2.jpg',
      date: 'April 19',
      title: "The worst advice we've ever heard about web design",
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    },
    {
      img: 'assets/images/blogs/blog-3.jpg',
      date: 'April 19',
      title: '10 things nobody told you about being a web designer',
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    },
    {
      img: 'assets/images/blogs/blog-4.jpg',
      date: 'April 19',
      title: 'Improving daily life with an AI meal plan',
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    },
    {
      img: 'assets/images/blogs/blog-5.jpg',
      date: 'April 19',
      title: '10 things nobody told you about being a web designer',
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    },
    {
      img: 'assets/images/blogs/blog-6.jpg',
      date: 'April 19',
      title: "The worst advice we've ever heard about web design",
      link: '/blog-standard',
      excerpt: 'Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus...'
    }
  ];
}
